import {
  REQUEST_ALD_TRIALS,
  RESPONSE_ALD_TRIALS,
  FAILURE_ALD_TRIALS,
  SORT_ALD_CLINICAL_TRIAL,
  ALD_CLINICAL_TRIAL_MORE_REQUEST,
  ALD_CLINICAL_TRIAL_MORE_FAILURE,
  ALD_CLINICAL_TRIAL_MORE_RESPONSE,
  CHANGE_ALD_CLINICAL_TRIAL_FILTER
} from "../../../actions/types";
import { combineReducers } from "redux";

import ClinicalTrialFilterReducer from "./ClinicalTrialFilterReducer";

const defaultKeywords = `LYSOSOMAL STORAGE DISORDER, FABRY'S DISEASE, METACHROMATIC LEUKODYSTROPHY, MUCOPOLYSACCHARIDOSIS, GAUCHER'S DISEASE, ADRENOLEUKODYSTROPHY,
 KRABBE, ENZYME REPLACEMENT THERAPY, STEM CELL TRANSPLANTATION, CELL AND GENE THERAPY`
  

const initialState = {
  keyword: defaultKeywords,
  isFetching: false,
  results: [],
  sortItem: { value: "CITATION", label: "Citation" },
  error: false,
  isInitalScreen: true,
  statusCode: 0,
  totalTrials: 0,
  from: 0,
  size: 10,
  isMoreResult: true,
  isMoreResultFetching: false,
  activePage: 1
};

const setFetching = (state, action) => {
  return {
    ...state,
    isFetching: true,
    results: [],
    isInitalScreen: false,
    statusCode: 0,
    totalTrials: 0,
    totalEnrollments: 0,
    totalSponsors: 0,
    from: 0,
    size: 10,
    isMoreResult: true
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
    results: [],
    totalTrials: 0,
    totalEnrollments: 0,
    totalSponsors: 0,
  };
};

const setResults = (state, action) => {
  let results = action.payload.results || [];
  let totalTrials = action.payload.totalTrials || 0;
  let totalEnrollments =  action.payload.totalEnrollments || 0;
  let totalSponsors = action.payload.totalSponsors || 0;
  let statusCode = action.payload.statusCode;
  let isMoreResult = true;

  if (totalTrials <= 10) {
    isMoreResult = false;
  }

  return {
    ...state,
    isFetching: false,
    error: false,
    results,
    totalTrials,
    totalEnrollments: totalEnrollments,
    totalSponsors: totalSponsors,
    isMoreResult,
    statusCode
  };
};

const setClinical = (state, action) => {
  let sortItem = action.payload.results || [];

  return {
    ...state,
    sortItem
  };
};

const setMoreResultResponse = (state, action) => {
  let from = action.payload.from || 0;
  let results = action.payload.results || [];
  let isMoreResult = true;
  let activePage = action.payload.activePage  || 1;

  if (results.length == 0) {
    isMoreResult = false;
  }
  results = [ ...results];

  return {
    ...state,
    results,
    from,
    isMoreResult,
    isMoreResultFetching: false,
    activePage: activePage
  };
};

const setMoreResultRequest = (state, action) => {
  return {
    ...state,
    isMoreResultFetching: true,
  };
};

const setMoreResultFailure = (state, action) => {
  return {
    ...state,
    isMoreResultFetching: false
  };
};

const updateKeyword = (state, action) => {
  
  let { terms=[] } = action.payload;
  terms = terms.map(l => l.value);
  let keyword = terms.join(', ');

   if(!keyword){
     keyword = state.keyword
   }
   return {
     ...state,
     keyword
   }

}


const ClinicalTrialReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_ALD_TRIALS:
      return setFetching(state, action);
      break;

    case RESPONSE_ALD_TRIALS:
      return setResults(state, action);

    case FAILURE_ALD_TRIALS:
      return setFailure(state, action);

    case SORT_ALD_CLINICAL_TRIAL:
      return setClinical(state, action);

    case ALD_CLINICAL_TRIAL_MORE_REQUEST:
      return setMoreResultRequest(state, action);

    case ALD_CLINICAL_TRIAL_MORE_RESPONSE:
      return setMoreResultResponse(state, action);

    case ALD_CLINICAL_TRIAL_MORE_FAILURE:
      return setMoreResultFailure(state, action);
    
    case CHANGE_ALD_CLINICAL_TRIAL_FILTER:
      return updateKeyword(state, action);

    default:
      return state;
      break;
  }
};

export default combineReducers({
  Filters: ClinicalTrialFilterReducer,
  Results: ClinicalTrialReducer
});
